<template>
    <div v-if="content" class="NotificationBar" :class="{'NotificationBar--hidden' : hideBar}">
        <div class="container">
            <p class="smaller" v-if="content.text">{{ content.text }}</p>
            <div class="NotificationBar__button-wrap">
                <BaseButton
                    v-if="content.buttonText && content.buttonLink"
                    :href="content.buttonLink"
                    modifier="small white"
                >
                    <span>{{ content.buttonText }}</span>
                </BaseButton>
                <BaseButton
                    @click="hide"
                    tag="button"
                    modifier="ghost-icon"
                >
                    <BaseIcon
                        icon="cross-icon"
                    />
                </BaseButton>

            </div>
        </div>
    </div>
</template>
<script>
import { EventBus } from '../scripts/event-bus';

export default {
    name: 'NotificationBar',
    props: {
        content: {
            type: Object,
            default: null
        }
    },
    data() {
        return {
            hideBar: true
        }
    },
    watch: {
        hideBar() {
            EventBus.$emit('notification', this.hideBar);
        }
    },
    created() {
        if (this.content && !document.cookie.includes(`hideNotificationBar${this.content.id}`)) {
            this.hideBar = false;
        } else {
            this.hideBar = true;
        }
    },
    methods: {
        hide() {
            this.hideBar = true;

            if (this.content) {
                document.cookie = `hideNotificationBar${this.content.id} = true`;
            }
        }
    }
}
</script>
<style lang="scss" scoped>
    .NotificationBar {
        position: relative;
        z-index: 15;
        background-color: getColour('blue');
        color: getColour('white');
        padding: getSpacing('small') 0;
        transition: .3s;

        .container {
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        p {
            @include media-query('palm') {
                font-size: 14px;
            }
        }
    }

    .NotificationBar--hidden {
        display: none;
    }

    .NotificationBar__button-wrap {
        flex-shrink: 0;
    }

    .BaseButton {
        flex-shrink: 0;
        margin-left: getSpacing('small');
    }
</style>
